import { Tag, Tooltip } from "antd";
import { IBlog } from "api/blog";

export const BlogTag = ({ data }: { data: IBlog }) => {
  return (
    <>
      {Array.isArray(data.detail_categories) &&
        data.detail_categories.length < 4 &&
        data.detail_categories.map((category) => (
          <Tag key={category._id}>{category.name}</Tag>
        ))}
      {Array.isArray(data.detail_categories) &&
        data.detail_categories.length > 3 && (
          <>
            <Tag key={data.detail_categories![0]._id}>
              {data.detail_categories![0].name}
            </Tag>
            <Tag key={data.detail_categories![1]._id}>
              {data.detail_categories![1].name}
            </Tag>
            <Tooltip
              title={
                <>
                  {data.detail_categories.slice(2).map((category) => (
                    <Tag key={category._id}>{category.name}</Tag>
                  ))}
                </>
              }
            >
              <Tag>+ {data.detail_categories.length! - 2}</Tag>
            </Tooltip>
          </>
        )}
    </>
  );
};
